import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import _ from "lodash";
import { twMerge } from "tailwind-merge";
import {
  PopoverPanel as HeadlessPopoverPanel,
  TransitionRoot,
} from "@headlessui/vue";
import { useAttrs, computed } from "vue";

interface PanelProps extends ExtractProps<typeof HeadlessPopoverPanel> {
  as?: string | object;
  placement?:
    | "top-start"
    | "top"
    | "top-end"
    | "right-start"
    | "right"
    | "right-end"
    | "bottom-end"
    | "bottom"
    | "bottom-start"
    | "left-start"
    | "left"
    | "left-end";
}
// eslint-disable-next-line

const __default__ = {
  inheritAttrs: false,
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'Panel',
  props: {
    as: null,
    placement: null
  },
  setup(__props: any) {

const props = __props as {
  as?: string | object;
  placement?:
    | "top-start"
    | "top"
    | "top-end"
    | "right-start"
    | "right"
    | "right-end"
    | "bottom-end"
    | "bottom"
    | "bottom-start"
    | "left-start"
    | "left"
    | "left-end";
}



const attrs = useAttrs();
const computedClass = computed(() =>
  twMerge([
    "p-2 shadow-[0px_3px_20px_#0000000b] bg-white border-transparent rounded-md dark:bg-darkmode-600 dark:border-transparent",
    typeof attrs.class === "string" && attrs.class,
  ])
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    as: "template",
    enter: "transition-all ease-linear duration-150",
    enterFrom: "mt-5 invisible opacity-0 translate-y-1",
    enterTo: "mt-1 visible opacity-100 translate-y-0",
    entered: "mt-1",
    leave: "transition-all ease-linear duration-150",
    leaveFrom: "mt-1 visible opacity-100 translate-y-0",
    leaveTo: "mt-5 invisible opacity-0 translate-y-1"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass([
        'absolute z-30',
        { 'left-0 bottom-[100%]': __props.placement == 'top-start' },
        { 'left-[50%] translate-x-[-50%] bottom-[100%]': __props.placement == 'top' },
        { 'right-0 bottom-[100%]': __props.placement == 'top-end' },
        { 'left-[100%] translate-y-[-50%]': __props.placement == 'right-start' },
        { 'left-[100%] top-[50%] translate-y-[-50%]': __props.placement == 'right' },
        { 'left-[100%] bottom-0': __props.placement == 'right-end' },
        { 'top-[100%] right-0': __props.placement == 'bottom-end' },
        { 'top-[100%] left-[50%] translate-x-[-50%]': __props.placement == 'bottom' },
        { 'top-[100%] left-0': __props.placement == 'bottom-start' },
        { 'right-[100%] translate-y-[-50%]': __props.placement == 'left-start' },
        { 'right-[100%] top-[50%] translate-y-[-50%]': __props.placement == 'left' },
        { 'right-[100%] bottom-0': __props.placement == 'left-end' },
      ])
      }, [
        _createVNode(_unref(HeadlessPopoverPanel), _mergeProps({
          as: __props.as,
          class: _unref(computedClass)
        }, _unref(_).omit(_unref(attrs), 'class')), {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }, 16, ["as", "class"])
      ], 2)
    ]),
    _: 3
  }))
}
}

})